import { Selection, EnterElement } from "d3"
import { D3OneToOneRenderable } from "./D3OneToOneRenderable"

export type D3LineConfig = {
    x1: number
    x2: number
    y1: number
    y2: number
    color: string
    isDashed: boolean
    clipPathId: string
    transitionDuration: number
    strokeWidth: number
}

export class D3Line extends D3OneToOneRenderable<SVGGElement, SVGLineElement, D3LineConfig> {
    protected enter = (newElements: Selection<EnterElement, D3LineConfig, any, any>): Selection<SVGLineElement, D3LineConfig, any, any> => {
        const lines = newElements.append("line")
            .attr("class", this.className)
            .attr("stroke", this.config.color)
            .attr("stroke-dasharray", this.config.isDashed ? '5,5' : null)
            .attr("clip-path", `url(#${this.config.clipPathId})`)
            .attr("stroke-width", this.config.strokeWidth)
            
        lines.transition().duration(this.config.transitionDuration)
            .attr("x1", this.config.x1)
            .attr("x2", this.config.x2)
            .attr("y1", this.config.y1)
            .attr("y2", this.config.y2)

        return lines
    }

    protected update = (updatedElements: Selection<SVGLineElement, D3LineConfig, any, any>): Selection<SVGLineElement, D3LineConfig, any, any> => {
        const lines = updatedElements
            .attr("stroke", this.config.color)
            .attr("stroke-dasharray", this.config.isDashed ? '5,5' : null)
            .attr("clip-path", `url(#${this.config.clipPathId})`)
            .attr("stroke-width", this.config.strokeWidth)
            
        lines.transition().duration(this.config.transitionDuration)
            .attr("x1", this.config.x1)
            .attr("x2", this.config.x2)
            .attr("y1", this.config.y1)
            .attr("y2", this.config.y2)

        return lines
    }
}
